import React, {useEffect} from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'

import provincesData from '../../assets/data/provinces.json';

const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const Province = (props) => {
  const handleClick = (id,value) => {
    props.setCurrentProvince(id,value)
    props.history.push('/select-current-district');
  }

  useEffect(() => window.scrollTo(0,0));

  return (
    <Layout title={'จังหวัด'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกจังหวัด</h4>
      <Row>
        {
          provincesData.map(element =>
            <StyledCol key={element.id}>
              <Text onClick={() => handleClick(element.id,element.th)}>{element.th}</Text>
              <Divider floatRight={true}/>
            </StyledCol>
          )
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setCurrentProvince: actions.setCurrentProvince,
}

const ProvinceWithConnect = connect(null, mapDispatchToProps)(Province)

export default ProvinceWithConnect
